import { createSlice } from "@reduxjs/toolkit";
import type { CurrencyPrimitive } from "@/api/cashier";
import type { AmountValidationError } from "@/hooks/deposit/useAmountValidator";
import { EFormIds } from "@/utils/enums";

export type TAmountFormData = {
  rate: number;
  tradingValue: number;
  processingValue: number;
  selectedProcessingCurrency?: CurrencyPrimitive;
  amountIsLoading: boolean;
  amountInputPending: boolean;
  externalProcessingCurrency?: CurrencyPrimitive;
  externalTradingAmount?: number;
  externalProcessingAmount?: number;
  validationError: AmountValidationError;
  fee?: string;
};

export type TCreditCardFormData = {
  nameOnCard?: string;
  formValid?: boolean;
  network?: string;
};

type TSlice = {
  formData: {
    // biome-ignore lint/suspicious/noExplicitAny: PNX-1749
    [key: string]: any;
    [EFormIds.CreditCard]: TCreditCardFormData;
    [EFormIds.Amount]: TAmountFormData;
    isValid: boolean;
  };
};

const initialState: TSlice = {
  formData: {
    creditCardForm: {},
    amountForm: {
      amountIsLoading: false,
      amountInputPending: false,
      processingValue: 0,
      tradingValue: 0,
      rate: 0,
      selectedProcessingCurrency: undefined,
      externalProcessingCurrency: undefined,
      externalTradingAmount: undefined,
      externalProcessingAmount: undefined,
      validationError: null,
    },
    isValid: false,
  },
};

export const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    setForm: (state, action) => {
      state.formData[action.payload.formId] = action.payload.formData;
    },
    updateForm: (state, action) => {
      state.formData[action.payload.formId] = {
        ...state.formData[action.payload.formId],
        ...action.payload.formData,
      };
    },
    resetForm: (state) => {
      state.formData = {
        creditCardForm: state.formData.creditCardForm,
        amountForm: state.formData.amountForm,
        isValid: state.formData.isValid,
      };
    },
  },
});

export const { setForm, updateForm, resetForm } = formSlice.actions;

export default formSlice.reducer;
